import React from 'react';

import { Box, Typography } from '@mui/material';
import { DateTime } from 'luxon';

interface PropsType {
	name: string;
	date: string;
	text: string;
	withOutText?: boolean;
}

const spanStyles = {
	fontSize: '12px',
	fontWeight: 400,
	lineHeight: '20px',
	letterSpacing: '0.4px',
	margin: 0,
	color: '#32383E',
};

function TeacherComment({ name, date, text, withOutText = false }: PropsType) {
	if (!text && !withOutText) return null;

	const formattedDate = date && DateTime.fromISO(date).toFormat('dd/MM/yyyy H:mm');
	return (
		<>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
				{name && (
					<Typography
						component="p"
						sx={{
							fontSize: '14px',
							fontWeight: 700,
							lineHeight: '20px',
							letterSpacing: '0.25px',
							margin: 0,
							maxWidth: '100%',
							whiteSpace: 'nowrap',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							flex: 1,
						}}
					>
						{name}
					</Typography>
				)}
				{formattedDate && (
					<Typography component="span" sx={spanStyles}>
						{formattedDate}
					</Typography>
				)}
			</Box>
			<Typography
				variant="body2"
				component="div"
				dangerouslySetInnerHTML={{
					__html: text,
				}}
			/>
		</>
	);
}

export default TeacherComment;
